import { useQuery } from '@tanstack/react-query';
import { AlertApi, IGetAlertsParams } from '../../../apis/AlertApi/AlertApi';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { IClinicalAlert } from '../Alert';

export function useAlerts(params?: IGetAlertsParams) {
    return useQuery<IClinicalAlert[]>({
        queryKey: [QueryKeys.alerts, params],
        queryFn: () => AlertApi.getAlerts(params),
    });
}
